// Backend base URL. Override at build time with REACT_APP_API_URL.
export const API_URL =
  process.env.REACT_APP_API_URL || "https://qkart-backend-2-pjkt.onrender.com/api/v1";
